<template>
  <div class="objects-views" v-loading="loader">
    <div class="list-objects tree">
      <div :class="{'header-row' : !isModal}">
        <div class="project-name">
          <span>Зоны работ</span>
          <img  v-if="isModal" style="cursor: pointer" src="@/assets/settings.svg" @click="$emit('edit-zone', 'all')"/>
        </div>
        <div>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end" v-if="!isModal">
        <a :href="dirUrl" style="margin-right: 10px">
          <el-button class="add-new-object">Выгрузить в эксель</el-button>
        </a>
        <AddDir @update="newObject">
          <el-button class="add-new-object">+ Добавить зону работ</el-button>
        </AddDir>
      </div>
      <div style="display: flex;" v-else>
          <el-button class="add-new-object" size="small">Импорт из excel</el-button>
      </div>
      <nested-draggable
        @edit-zone="(id) => $emit('edit-zone', id)"
        :isMain="true"
        :is-modal="isModal"
        @update="newObject"
        @input="updateTree"
        :value="list"
        v-if="list && list.length"
      />
      <div v-else class="warn">
        <el-alert
          title="У вас нет разделов"
          type="warning"
          description="Вы можете создать раздел кликнув на кнопку в правом верхнем углу"
          show-icon
        >
        </el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import nestedDraggable from './components/List';
import firebase from 'firebase';
import {getChild} from '@/utils/getChild';
import {flatten} from '../../../../utils/getChild';
import _ from 'lodash';
import AddObject from './components/AddDir';
import AddDir from "./components/AddDir";
import {apiUrl} from "../../../../plugins/firebase";

export default {
  name: 'ZoneIndex',
  props: {
    isModal: Boolean
  },
  components: {
    AddDir,
    nestedDraggable,
    AddObject
  },
  computed: {
    dirUrl() {
      const params = encodeURIComponent(`/onGenerateTemplateZones/${this.$store.state.project.id}`)
      return `${apiUrl}${params}`;
    }
  },
  methods: {
    fire() {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    async newObject() {
      await this.fetchTree();
      this.updateTree(this.list);
    },
    updateTree: _.debounce(function (tree) {
      this.list = [...tree];
      const jobs = flatten(this.list);

      jobs.forEach((job, i) => {
        this.update({...job, index: i});
      });
    }, 500),
    update(data) {
      this.fire()
        .collection('zones')
        .doc(data.id)
        .update({
          index: data.index,
          name: data.name || null,
          parentId: data.parentId || null,
        });
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      return this.fire()
        .collection('zones')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              index: data.index,
              name: data.name,
              objects: data.objects || [],
              parentId: data.parentId || undefined,
            });
          });
        }).finally(() => {
          this.list = getChild(_.orderBy(result, 'index', ['asc']));

          this.loader = false;
        }).catch((e) => {
          this.loader = false;
        });
    },
  },

  mounted() {
    this.fetchTree();
  },


  data() {
    return {
      list: [],
      loader: false,
    };
  },
};
</script>

<style lang="scss">
.objects-views {
  display: flex;
  flex-direction: column;
  align-items: center;

  .list-objects {
    max-width: 600px;
    width: calc(100% - 20px);
  }

  .project-name {
    font-size: 16px;
    margin-top: 42px;
    display: flex;
    align-items: flex-end;
    background: #fff;
    justify-content: flex-start;
    padding: 0 10px;
    font-weight: bold;
  }
}

.tree, .tree ul {
  font: normal normal 14px/20px Helvetica, Arial, sans-serif;
  list-style-type: none;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.tree li {
  margin: 0;
  padding: 0 0 0 20px;
  position: relative;
}

.tree li::before, .tree li::after {
  content: '';
  position: absolute;
  left: 0;
}

/* horizontal line on inner list items */
.tree li::before {
  border-top: 1px solid #ccc;
  top: 24px;
  width: 20px;
  height: 0;
}

/* vertical line on list items */
.tree li:after {
  border-left: 1px solid #ccc;
  height: 100%;
  width: 0px;
  top: -55px;
}

.tree > li::after {
  top: -55px;
}

.tree > li:last-child::after {
  display: none !important;
}

.add-new-object {
  cursor: pointer;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}

.warn {
  margin-top: 20px;
}

.fa-edit {
  color: #1e1e21 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/Zone/Index.vue